class CollectionFilters extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      filterByItem: '[data-filter-by-item]',
      filterList: '[data-filter-list]',
      productGridItem: '[data-product-grid-item]',
      sortByItem: '[data-sort-by-item]'
    }

    this.classes = {
      active: 'active',
      hidden: 'hidden',
      loading: 'loading',
      isFiltered: 'is-filtered'
    }

    this.data = {
      filter: 'filter',
      defaultSortBy: 'defaultSortby',
      productTags: 'productTags',
      value: 'value'
    }

    this.attr = {
      productTags: 'data-product-tags',
      value: 'data-value'
    }

    this.cache = {
      sortBy: {}
    }
    
    this.settings = {
      filterBy: {},
      sortBy: {
        sort_by: ''
      }
    }
    
    this.filterByItem = this.querySelectorAll(this.selectors.filterByItem);
    this.filterList = this.querySelectorAll(this.selectors.filterList);
    this.productItem = document.querySelectorAll(this.selectors.productGridItem);
    this.sortByItem = this.querySelectorAll(this.selectors.sortByItem);

    this.initEvents();
    this.filterBasedOnUrl();
    
  }

  initEvents() {
    this.filterByItem?.forEach(fbi => fbi.addEventListener('click', this.onFilterByItemClick.bind(this)));
    this.sortByItem?.forEach(sbi => sbi.addEventListener('click', this.onSortByItemClick.bind(this)));
  }

  onFilterByItemClick(e) {
    const target = e.currentTarget;
    const value = target.dataset[this.data.value];
    const filter = target.closest(this.selectors.filterList).dataset[this.data.filter];
    
    if(!this.settings.filterBy.hasOwnProperty(filter))
      this.settings.filterBy[filter] = [];
    
    target
      .classList
      .toggle(this.classes.active);
    
    if(target.classList.contains(this.classes.active)) {
      this.settings.filterBy[filter]
          .push(value);
      
    } else {
      this.settings.filterBy[filter]
          .splice(this.settings.filterBy[filter].indexOf(value), 1);
      
    }

    if (!this.settings.filterBy[filter].length) {
      delete this.settings.filterBy[filter];
      
    }
    
    this.filterItems();
    this.updateUrl();
    
  }

  filterItems(){
    this.productItem
        .forEach(pi => {
          pi.classList.remove(this.classes.isFiltered);
          pi.style.display = '';
        });
  
    for (let key in this.settings.filterBy) {
      if (!this.settings.filterBy[key].length) continue;

      var filter = `:not(.${this.classes.isFiltered})`;

      for (var index in this.settings.filterBy[key]) {
        filter += `:not([${this.attr.productTags}*="[${this.settings.filterBy[key][index]}]"])`;

      }

      this.productItem
        .forEach(pi => {
          if (pi.matches(filter)) {
            pi.classList.add(this.classes.isFiltered);
            pi.style.display = 'none';
          }
        });
      
    }

  }

  filterBasedOnUrl(){
    const urlParams = new URLSearchParams(window.location.search)
    if (!urlParams.size) return;
    
    let filters = [];
    let filterData = {};

    this.filterList.forEach(fl => filters.push(fl.dataset[this.data.filter]));
    filters.forEach(filter => {
        if (urlParams.has(filter)) {
          this.settings.filterBy[filter] = urlParams.get(filter).split(',');
        }
      });

    if (!Object.keys(this.settings.filterBy).length) return;

    this.filterItems();
    this.toggleActiveFilters();
    
  }

  toggleActiveFilters() {
    for (let filter in this.settings.filterBy) {
      let filterList = [...this.filterList].find(fl => fl.dataset[this.data.filter] === filter);

      this.settings.filterBy[filter].forEach((fi) => {
        filterList.querySelector(`${this.selectors.filterByItem}[${this.attr.value}="${fi}"]`)?.classList.add(this.classes.active);
      });
        
    }
  }

  onSortByItemClick(e) {
    const target = e.currentTarget;
    const sortBy = target.dataset[this.data.value];

    this.sortByItem.forEach(sbi => sbi.classList.remove(this.classes.active));
    target.classList.add(this.classes.active);

    document.getElementById('ProductGridContainer')
      .querySelector('.collection')
      .classList.add(this.classes.loading);
    
    Object.keys(this.cache.sortBy).some(sort => sort === sortBy) ?
      this.renderSortedElements(this.cache.sortBy[sortBy]) :
      this.fetchSortedElements(sortBy);
    
  }

  fetchSortedElements(sortBy) {
    fetch(`${window.location.pathname}?section_id=${document.getElementById('product-grid').dataset.id}&sort_by=${sortBy}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        console.log(html)
        this.cache.sortBy[sortBy] = html;
        this.renderSortedElements(html);
      });
  }

  renderSortedElements(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;
  }

  createSearchParams() {

  }

  updateUrl() {
    const searchParams = new URLSearchParams(this.settings.filterBy).toString();
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    
  }
  
}

customElements.define('collection-filters', CollectionFilters);